import type { ReactNode } from 'react';
import { usePermissions } from '../usePermissions';
import type { LineId, PermissionAction } from '../permissionTypes';

interface PermissionGateProps {
  /** Catalogue line the display of `children` is gated on. */
  line: LineId;
  /** Action to check; defaults to `display`. */
  action?: PermissionAction;
  /** Rendered when the permission is missing (default: nothing). */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Conditional-display wrapper (HOMCO-640): renders `children` only when the
 * connected profile is granted `action` on `line`, otherwise `fallback`. Refused
 * by default — hidden while permissions are not yet loaded (`can` returns false).
 * Not a security boundary (the backend enforces); it only avoids showing UI whose
 * API calls would 403.
 */
export function PermissionGate({
  line,
  action = 'display',
  fallback = null,
  children,
}: PermissionGateProps) {
  const { can } = usePermissions();
  return <>{can(line, action) ? children : fallback}</>;
}
